/* eslint-disable react-hooks/exhaustive-deps */
import { usePlayerData } from "../../../hooks/usePlayerData";
import Floating from "../../miscellaneous/Floating";
import Header from "../../miscellaneous/Header";
import Footer from "../../miscellaneous/Footer";
import { useEffect, useRef, useState } from "react";
// import { Draw } from "../../../models/Draw";
import { DRAWS_IN_PAGE } from "../../../utils/Constants";
// import DrawCard from "../../miscellaneous/DrawCard";
// import DrawDialog from "../../dialogs/DrawDialog";
// import { useDialog } from "../../../hooks/useDialog";
import { PageNavigator } from "./components/PageNavigator";
import { ScrollRestoration } from "react-router-dom";
import { Draw } from "../../../models/Draw";
import DrawDialog from "../../dialogs/DrawDialog";
import DrawCard from "../../miscellaneous/DrawCard";
import { useDialog } from "../../../hooks/useDialog";
import {
  HistoryFilter,
  HistoryFilterOptions,
} from "../../../models/HistoryFilter";

export default function HistoryPage() {
  /**
   * Hooks
   */
  const {
    address,
    connectWallet,
    fetchDrawsInPage,
    drawsInHistory,
    drawInfo,
    updatingDraws,
    playerStatistics,
    charities,
  } = usePlayerData();

  const { openDialog, closeDialog } = useDialog();
  const [options, setOptions] = useState<HistoryFilterOptions>(
    new HistoryFilterOptions(
      0,
      HistoryFilter.ALL,
      drawInfo?.drawNumber == undefined ? 1n : drawInfo?.drawNumber - 1n,
    ),
  );
  const [starting, setStarting] = useState<boolean>(true);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      setStarting(false);
      return;
    }
    fetchDrawsInPage(options.page, options.filter).then(() => {
      setStarting(false);
    });
  }, [options]);

  /**
   * On Draw Click
   */
  function onOpenDraw(draw: Draw): void {
    openDialog(
      <DrawDialog
        draw={draw}
        announce={false}
        address={address}
        onClose={closeDialog}
      ></DrawDialog>,
    );
  }

  const pageNavigator = (
    <PageNavigator
      currentPage={options.page + 1}
      onPageChange={function (page: number): void {
        if (updatingDraws || starting) return;
        setOptions((options) => options.copyWithPage(page - 1));
      }}
      totalPages={Math.floor((Number(options.total) - 1) / DRAWS_IN_PAGE) + 1}
    ></PageNavigator>
  );

  /**
   * Set filter, reset page
   */
  function onSelectFilter(filter: HistoryFilter): void {
    let total: bigint;
    switch (filter) {
      case HistoryFilter.ALL:
        total =
          drawInfo?.drawNumber == undefined ? 1n : drawInfo?.drawNumber - 1n;
        break;
      case HistoryFilter.PLAYED:
        total = playerStatistics.drawsEntered;
        break;
      case HistoryFilter.BENEFITED:
        total =
          charities.find(
            (charity) =>
              charity.address?.toLowerCase() == address?.toLowerCase(),
          )?.drawsInvolved ?? 0n;
        break;
    }
    setOptions(new HistoryFilterOptions(0, filter, total));
  }

  const noEntries: boolean = (options.total ?? 0n) <= 0;

  return (
    <div className={`flex flex-col min-h-screen w-full items-center`}>
      <ScrollRestoration />
      <Floating
        isConnected={address != undefined}
        connectWallet={connectWallet}
      ></Floating>
      <div className="flex-grow flex flex-col w-full items-center">
        <Header></Header>
        <p
          className="text-center ~text-lg/xxl ~leading-5/6 font-barlowc font-bold text-silver ~mb-8/12 ~mt-10/8"
          data-aos="fade-left"
          data-aos-delay="200"
        >
          ALL-TIME DRAW HISTORY
        </p>
        <div className="flex flex-wrap w-1/2 justify-center ~gap-2.5/5 ~mb-3/4 ~text-xs/sm text-center font-poppins text-silver">
          <div
            className={`cursor-pointer ~px-2/4 ~py-1/2 duration-250 ${options.filter === HistoryFilter.ALL ? "bg-bastille" : "bg-transparent"}`}
            onClick={function (): void {
              onSelectFilter(HistoryFilter.ALL);
            }}
          >
            SHOW ALL
          </div>
          <div
            className={`cursor-pointer ~px-2/4 ~py-1/2 duration-250 ${options.filter === HistoryFilter.PLAYED ? "bg-bastille" : "bg-transparent"}`}
            onClick={function (): void {
              onSelectFilter(HistoryFilter.PLAYED);
            }}
          >
            SHOW PLAYED ONLY
          </div>
          <div
            className={`cursor-pointer ~px-2/4 ~py-1/2 duration-250 ${options.filter === HistoryFilter.BENEFITED ? "bg-bastille" : "bg-transparent"}`}
            onClick={function (): void {
              onSelectFilter(HistoryFilter.BENEFITED);
            }}
          >
            SHOW BENEFITED ONLY
          </div>
        </div>
        {noEntries ? (
          <div className="~text-base/lg font-poppins text-gray">
            Nothing to see here.
          </div>
        ) : (
          <div className="relative min-h-[200px]">
            {" "}
            {/* Ensure there's space for layout */}
            {/* Spinner */}
            <div
              className={`absolute top-0 left-0 w-full h-full flex justify-center items-center transition-opacity duration-500 ${
                updatingDraws || starting
                  ? "opacity-100 pointer-events-auto"
                  : "opacity-0 pointer-events-none"
              }`}
            >
              <svg
                className="animate-spin h-16 w-16 text-dolphin"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                ></path>
              </svg>
            </div>
            {/* Draws List */}
            <div
              className={`flex flex-wrap justify-center items-center ~gap-2.5/5 ~mt-3/4 ~mb-3/4 ~mx-8/12 transition-opacity duration-500 ${
                updatingDraws || starting
                  ? "opacity-0 pointer-events-none"
                  : "opacity-100 pointer-events-auto"
              }`}
            >
              {drawsInHistory.map((draw: Draw) => (
                <DrawCard
                  key={draw.number.toString()}
                  draw={draw}
                  onClick={() => onOpenDraw(draw)}
                  address={address}
                />
              ))}
            </div>
            {!(updatingDraws || starting) && pageNavigator}
          </div>
        )}
      </div>
      <Footer></Footer>
    </div>
  );
}
